import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Award, Clock, Users, Target, TrendingUp } from 'lucide-react';
import { services } from '../mockData';
import './Services.css';

const Services = () => {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <div className="services-hero-content text-center fade-in">
            <h1 className="display-medium mb-lg">What we can help you with?</h1>
            <p className="body-large text-gray" style={{maxWidth: '720px', margin: '0 auto'}}>
              Choose the perfect program for your fitness journey. All our services are backed by science and personalized to your unique goals.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-content section">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={service.id} className="service-card card fade-in" style={{animationDelay: `${index * 0.2}s`}}>
                <div className="service-image-wrapper">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="service-image"
                  />
                </div>
                <div className="service-content">
                  <h3 className="heading-2 mb-md">{service.title}</h3>
                  <p className="body-medium text-gray mb-lg">{service.description}</p>
                  
                  <div className="service-features mb-xl">
                    <h4 className="body-medium mb-md" style={{fontWeight: 600}}>What's included:</h4>
                    <ul className="features-list">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="feature-list-item">
                          <CheckCircle size={18} className="feature-check" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <Link to="/contact" className="btn btn-primary" style={{width: '100%'}}>
                    Book Consultation
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Credentials Section */}
      <section className="credentials-section section-large">
        <div className="container">
          <div className="section-header text-center mb-2xl">
            <h2 className="heading-1 mb-md">Why Choose Sympozium</h2>
            <p className="body-large text-gray">Certified expertise backed by proven results</p>
          </div>
          
          <div className="credentials-grid">
            <div className="credential-card card card-hover fade-in">
              <div className="credential-icon">
                <Award size={32} />
              </div>
              <h3 className="heading-3 mb-sm">Certified Professionals</h3>
              <p className="body-medium text-gray">
                All our trainers are certified and have years of hands-on experience.
              </p>
            </div>
            
            <div className="credential-card card card-hover fade-in" style={{animationDelay: '0.1s'}}>
              <div className="credential-icon">
                <Target size={32} />
              </div>
              <h3 className="heading-3 mb-sm">Personalized Approach</h3>
              <p className="body-medium text-gray">
                Every program is customized to your body type, fitness level, and lifestyle to ensure maximum results and sustainability.
              </p>
            </div>
            
            <div className="credential-card card card-hover fade-in" style={{animationDelay: '0.2s'}}>
              <div className="credential-icon">
                <TrendingUp size={32} />
              </div>
              <h3 className="heading-3 mb-sm">Proven Track Record</h3>
              <p className="body-medium text-gray">
                With a 98% success rate and over 500 transformed clients, we have the results to back our methods.
              </p>
            </div>
            
            <div className="credential-card card card-hover fade-in" style={{animationDelay: '0.3s'}}>
              <div className="credential-icon">
                <Clock size={32} />
              </div>
              <h3 className="heading-3 mb-sm">Flexible Scheduling</h3>
              <p className="body-medium text-gray">
                Train on your schedule with flexible booking options for in-person and online sessions.
              </p>
            </div>
            
            <div className="credential-card card card-hover fade-in" style={{animationDelay: '0.4s'}}>
              <div className="credential-icon">
                <Users size={32} />
              </div>
              <h3 className="heading-3 mb-sm">Ongoing Support</h3>
              <p className="body-medium text-gray">
                Get continuous support and accountability through regular check-ins and access to your coach.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta section">
        <div className="container">
          <div className="cta-box">
            <div className="cta-box-content">
              <h2 className="heading-1 mb-md">Not Sure Which Program Is Right For You?</h2>
              <p className="body-large text-gray mb-xl">
                Schedule a free consultation and we'll help you find the perfect fit for your goals and lifestyle.
              </p>
              <Link to="/contact" className="btn btn-primary btn-large">
                Book Free Consultation
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;